var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";
import { RefreshIcon } from "@heroicons/react/outline";
var buttonVariants = cva("inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-zinc-950 disabled:pointer-events-none disabled:opacity-50 uppercase", {
    variants: {
        variant: {
            default: "bg-zinc-900 text-zinc-50 shadow hover:bg-zinc-900/90",
            destructive: "bg-red-500 text-zinc-50 shadow-sm hover:bg-red-500/90",
            outline: "border border-zinc-200 bg-transparent shadow-sm hover:bg-zinc-100 hover:text-zinc-900",
            secondary: "bg-zinc-100 text-zinc-900 shadow-sm hover:bg-zinc-100/80",
            ghost: "hover:bg-zinc-100 hover:text-zinc-900",
            link: "text-zinc-900 underline-offset-4 hover:underline",
        },
        size: {
            default: "h-9 px-4 py-2",
            sm: "h-8 rounded-md px-3 text-xs",
            lg: "h-10 rounded-md px-8",
            icon: "h-9 w-9",
        },
    },
    defaultVariants: {
        variant: "default",
        size: "default",
    },
});
var Button = React.forwardRef(function (_a, ref) {
    var className = _a.className, variant = _a.variant, size = _a.size, _b = _a.asChild, asChild = _b === void 0 ? false : _b, loading = _a.loading, children = _a.children, props = __rest(_a, ["className", "variant", "size", "asChild", "loading", "children"]);
    var Comp = asChild ? Slot : "button";
    return (React.createElement(Comp, __assign({ className: cn(buttonVariants({ variant: variant, size: size, className: className }), {
            "cursor-wait": loading,
            "opacity-50": loading,
            "pointer-events-none": loading,
        }), ref: ref }, props), loading ? React.createElement(RefreshIcon, { className: "animate-spin h-5 w-5" }) : children));
});
Button.displayName = "Button";
export { Button, buttonVariants };
